// @flow

import {KB_API_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {
  get,
  createErrorHandler,
  postJson,
  patchJson,
  showForbiddenMessageHandler,
} from 'app/utils/request';
import {limitRequests} from 'app/utils/redux';
import type {KnowledgeBaseType} from 'app/kbs/types';

/* == KBActionType should contain all action types ==*/

export type KnowledgebaseActionType =
  | RequestKBsDashboardListType
  | ReceiveKBDetailActionType;

/* === request kbs === */

export const REQUEST_KBS_DASHBOARD_LIST = 'REQUEST_KBS_DASHBOARD_LIST';

type RequestKBsDashboardListType = {
  type: 'REQUEST_KBS_DASHBOARD_LIST',
  currentFilters: {},
};

export const requestKBsDashboardList = (currentFilters: {}) => ({
  type: REQUEST_KBS_DASHBOARD_LIST,
  currentFilters,
});

/* === create kb === */

export const createNewKB =
  (data: {name: string}) => (dispatch: SimpleDispatch) =>
    // https://twitter.com/dan_abramov/status/770914221638942720
    postJson(KB_API_URL, data).then(
      (kb: KnowledgeBaseType) => dispatch(receiveKBDetail(kb)).kb,
      createErrorHandler(gt('Could not create the Knowledge Base.'), dispatch)
    );

/* === fetch single kb === */

export const RECEIVE_KB_DETAIL = 'RECEIVE_KB_DETAIL';

type ReceiveKBDetailActionType = {
  type: 'RECEIVE_KB_DETAIL',
  kb: KnowledgeBaseType,
};

const receiveKBDetail = (kb: KnowledgeBaseType): ReceiveKBDetailActionType => ({
  type: RECEIVE_KB_DETAIL,
  kb,
});

export const getKBByHashid = limitRequests(
  (hashid: string) => (dispatch: SimpleDispatch) =>
    get(`${KB_API_URL}${hashid}/`).then((kb) => dispatch(receiveKBDetail(kb)))
);

/* === update kb === */

export const updateKB =
  (url: string, data: $Shape<KnowledgeBaseType>) =>
  (dispatch: SimpleDispatch) =>
    patchJson(url, data).then(
      (kb) => dispatch(receiveKBDetail(kb)),
      createErrorHandler(
        gt('Unable to update the Knowledge Base'),
        dispatch,
        showForbiddenMessageHandler(true)
      )
    );
